module.exports = __webpack_public_path__ + "static/img/2.a24ac98.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/active/snail/fifth/hk/2.png
// module id = OlMp
// module chunks = 1 3